/**
 * Push a custom event to the Google Tag Manager dataLayer.
 *
 * The container is loaded in public/index.html (see
 * public/static/scripts/gtm.js). This helper only appends to a local array —
 * it sends nothing anywhere — so it needs no consent gate: whether GTM
 * forwards the event to GA4, Meta or anything else is decided by the Consent
 * Mode signals Cookiebot sends (defaults in
 * public/static/scripts/gcm-consent-defaults.js). A queued event is still
 * forwarded if the visitor consents later in the same page session.
 *
 * Sibling of trackEvent(), which talks to GA4 directly via gtag. Use this one
 * for events Guro needs to build triggers on inside the GTM container; use
 * trackEvent for events that should land in GA4 regardless of the container.
 *
 * No-op on the server and if anything throws — analytics must never break the
 * UI or an auth flow.
 *
 * @param {string} event - dataLayer event name, e.g. 'sign_up'
 * @param {Object} [params] - extra keys to merge into the pushed object
 */
export const pushDataLayerEvent = (event, params = {}) => {
  if (typeof window === 'undefined' || !event) {
    return;
  }
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) {
    // Analytics must never break the UI.
  }
};
